import React from "react";

const FinancialSolutions = () => {
  const solutions = [
    {
      image: "/a1.png",
      title: "Instant Personal Loan",
      headline: "Cover life's unexpected moments without financial stress.",
      features: [
        "Minimal documentation",
        "Fast approval",
        "Flexible EMI plans"
      ]
    },
    {
      image: "/a2.png",
      title: "Business Growth Loans",
      headline: "Fuel your business expansion with quick working capital.",
      features: [
        "Fast approvals",
        "Flexible repayment",
        "Business friendly terms"
      ]
    },
    {
      image: "/a3.png",
      title: "Loan Against Property",
      headline: "Turn your property into financial opportunity.",
      features: [
        "Higher loan amounts",
        "Lower interest rates",
        "Long repayment tenure"
      ]
    }
  ];

  return (
    <section className="relative w-full py-12 md:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            <span className="text-slate-800">Financial Solutions Designed</span>
            <br />
            <span className="text-blue-600">For Every Stage Of Life</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Whether it's a personal need, business expansion, or unlocking property value we have the right financing solution.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="flex flex-wrap lg:flex-nowrap justify-center gap-6 md:gap-8">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 w-full md:w-[434px] lg:w-[434px] md:h-[472px] flex-shrink-0"
            >
              {/* Image */}
              <div className="overflow-hidden w-full md:w-[435px] md:h-[171px]">
                <img
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6 text-left flex flex-col h-[301px]">
                {/* Title Badge - Blue Pill */}
                <div className="inline-block bg-blue-600 text-white px-4 py-1.5 rounded-full text-xs font-semibold mb-3 w-fit">
                  {solution.title}
                </div>

                {/* Headline - Dark Bold Text */}
                <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-4 leading-tight">
                  {solution.headline}
                </h3>

                {/* Features - Blue Circle Bullets */}
                <ul className="space-y-2.5 flex-grow">
                  {solution.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2.5">
                      <div className="w-2 h-2 rounded-full bg-blue-600 flex-shrink-0 mt-1.5" />
                      <span className="text-sm text-slate-700 leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinancialSolutions;

